// import { useDispatch } from "react-redux";
import ApiConfig from "../../Utils/Configs/apiConfig";

// import {
//   setToken,
//   setAuthenticated,
//   setUserType,
// } from "../../Reducer/AuthReducer";
export const AuthenticationService = async (
  email: string,
  password: string
) => {
  // Sample Response for testing
  const payload = {
    email: email,
    password: password,
  };
  const SampleResponse = {
    UserID: "123",
    username: "testUser",
    Role: "admin", // 0- > admin, 1-> clientuser
    jwt: "samplecvvdf",
  };
  try {
    // const response = await ApiConfig.getInstance().post("/api/Account/login");

    // sanitize or filter -? only needed data is returned to the component
    //localStorage.setItem("token", SampleResponse.jwt);
    localStorage.setItem("user", JSON.stringify(SampleResponse));

    //return response.data;
  } catch (error) {
    console.error("Error in Authenticate Api call ", error);
  }

  return SampleResponse;
};

interface LoginServiceProps {
  email: string;
  password: string;
}
export const LoginService = async (email: string, password: string) => {
  // const dispatch = useDispatch();
  const payload: LoginServiceProps = {
    email: email,
    password: password,
  };

  try {
    const jsonPayload = JSON.stringify(payload);

    const response = await ApiConfig.getInstance().post(
      "/Account/login",
      jsonPayload
    );

    // dispatch(setLoginState({ status: true }));
    const user = {
      userId: response.data.user.data.userId,
      firstName: response.data.user.data.firstName,
      roleId: response.data.user.data.roleId,
      jwt: response.data.token.result,
      email: response.data.user.data.email,
    };
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("token", user.jwt);
    // dispatch(setUserType({ userType: user.roleId }));
    // Include a message in the return object
    // return {
    //   user,
    //   message: "Login successful!",
    // };

    return { success: true, user, message: "Login successful!" };
  } catch (error: any) {
    console.error("Error in Authenticate Api call ", error);
    localStorage.removeItem("user");
    const errorMessage =
      error.response?.data?.message || "Something went wrong, try again!";
    return { success: false, message: errorMessage };
  }
};
